import React from "react";
import ReactMarkdown from "react-markdown";

import { useDimensionHydration } from "../../store/dimension.hydration";
import type {
    DimensionConfiguration,
    DimensionTemplate,
} from "../../types/dimensions";

import { ComplexDimensionBox } from "./common/components";

export interface MarkdownDimensionConfiguration extends DimensionConfiguration {
    md: string;
}

export interface MarkdownDimensionProps extends DimensionTemplate {
    configuration: MarkdownDimensionConfiguration;
}

export const MarkdownDimension: React.FunctionComponent<
    MarkdownDimensionProps
> = (props) => {
    const { id, dependencies } = props;
    useDimensionHydration(id, dependencies, async () => {
        // not logic required
    });

    return (
        <ComplexDimensionBox>
            <ReactMarkdown linkTarget="_blank">
                {props.configuration.md}
            </ReactMarkdown>
        </ComplexDimensionBox>
    );
};
